import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { LayoutProps, SpaceProps } from 'styled-system';

import { DarkSplashQueryQuery } from 'types/codegen';
import { buildSrcSet } from 'utils/string';

import { Background, Container, Content } from './styles';

type PropTypes = {
  children: React.ReactNode;
} & SpaceProps &
  LayoutProps &
  React.HTMLAttributes<HTMLDivElement>;

const DarkSplash = ({ children, ...props }: PropTypes): JSX.Element => {
  const data = useStaticQuery<DarkSplashQueryQuery>(graphql`
    query DarkSplashQuery {
      fhd: file(relativePath: { regex: "/main-background.jpg/" }) {
        childImageSharp {
          resize(width: 1920, cropFocus: CENTER, quality: 100) {
            src
            width
          }
        }
      }
      large: file(relativePath: { regex: "/main-background.jpg/" }) {
        childImageSharp {
          resize(width: 1600, cropFocus: CENTER, quality: 100) {
            src
            width
          }
        }
      }
      desktop: file(relativePath: { regex: "/main-background.jpg/" }) {
        childImageSharp {
          resize(width: 1366, cropFocus: CENTER, quality: 100) {
            src
            width
          }
        }
      }
      tablet: file(relativePath: { regex: "/main-background.jpg/" }) {
        childImageSharp {
          resize(width: 1024, cropFocus: CENTER, quality: 100) {
            src
            width
          }
        }
      }
      mobile: file(relativePath: { regex: "/main-background.jpg/" }) {
        childImageSharp {
          resize(width: 768, cropFocus: CENTER, quality: 100) {
            src
            width
          }
        }
      }
      small: file(relativePath: { regex: "/main-background.jpg/" }) {
        childImageSharp {
          resize(width: 640, cropFocus: CENTER, quality: 100) {
            src
            width
          }
        }
      }
    }
  `);

  const srcset = React.useMemo(() => buildSrcSet(data), [data]);

  return (
    <Container {...props}>
      <Background srcSet={srcset} alt="" />
      <Content>{children}</Content>
    </Container>
  );
};

export default DarkSplash;
